import { Event } from '@amplitude/analytics-types';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

import { initGTM, sendGoogleTagManagerEvent } from 'utils/google-tag-manager';

import { addAmplitudePlugin, flushAmplitudeEvents, initializeAmplitudeSdk } from './client.web';

export const initializeAmplitudeProvider = async (
  amplitudeKey: string,
  cognitoId: string | undefined,
  options: object
): Promise<void> => {
  await addAmplitudePlugin(sessionReplayPlugin({ sampleRate: 0.2 })).promise;

  let capturedSessionStartEvent: Event | undefined;
  await addAmplitudePlugin({
    name: 'session-start-capture',
    type: 'enrichment',
    execute: async (event: Event): Promise<Event> => {
      if (event.event_type === 'session_start') {
        capturedSessionStartEvent = event;
      }
      return event;
    },
  }).promise;

  await initializeAmplitudeSdk(amplitudeKey, cognitoId, options).promise;
  await flushAmplitudeEvents().promise;

  await addAmplitudePlugin({
    name: 'google-tag-manager',
    type: 'destination',
    setup: initGTM,
    execute: sendGoogleTagManagerEvent,
  }).promise;

  if (capturedSessionStartEvent) {
    await sendGoogleTagManagerEvent(capturedSessionStartEvent);
    capturedSessionStartEvent = undefined;
  }

  await addAmplitudePlugin(engagementPlugin()).promise;
};

/** Temporary compatibility name for the legacy package entrypoint. */
export const initAmplitudeWithPluginsForPlatform = initializeAmplitudeProvider;
